var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      this.type == "url"
        ? _c("el-upload", {
            ref: "upload",
            staticStyle: { display: "none" },
            attrs: {
              action: _vm.uploadUrl,
              "before-upload": _vm.handleBeforeUpload,
              "on-success": _vm.handleUploadSuccess,
              "on-error": _vm.handleUploadError,
              name: "file",
              "show-file-list": false,
              headers: _vm.headers
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "editor", staticClass: "editor", style: _vm.styles })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7480c5e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7480c5e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Editor/index.vue
// module id = null
// module chunks = 